// VH-227: small pure helpers shared by the health cycle components.

export const ACTIVE_STEP_STATUSES = new Set(['pending', 'running'])

export const isCycleActive = (cycle) =>
  !!cycle && (cycle.status === 'running' || (cycle.steps ?? []).some((s) => ACTIVE_STEP_STATUSES.has(s.status)))

/** A skipped step whose handler is not built yet names the feature: `not_available:VH-228`. */
export const notAvailableFeature = (step) => {
  const reason = step?.reason || ''
  return step?.status === 'skipped' && reason.startsWith('not_available') ? reason.split(':')[1] || null : null
}

/** Error code from `{"detail": <code>, ...}` responses. */
export const errorCode = (err) => {
  const detail = err?.response?.data?.detail
  return typeof detail === 'string' ? detail : null
}

export const localeFor = (language) =>
  language === 'de' ? 'de-DE' : language === 'pt-BR' ? 'pt-BR' : 'en-US'

export const formatDate = (value, language) =>
  value ? new Date(value).toLocaleDateString(localeFor(language)) : ''
